type RootCategory = { rootKey: string };

export const getFilteredCategories = (categories?: RootCategory[]) => {
  return categories ? [...categories] : [];
};

export const sortCategories = (categories: RootCategory[]) => {
  return [...categories].sort((a, b) =>
    a.rootKey.localeCompare(b.rootKey)
  );
};

export const areAllSelected = (
  categories: RootCategory[],
  selectedCategories: string[]
) => {
  return categories.every((category) =>
    selectedCategories.includes(category.rootKey)
  );
};
